<template>
  <div class="km__modules__pattern--subcategories">
    <ul class="km__list--modules" v-if="currentPatternCategory !==null">
      <li class="km__list__element--modules sub-pattern"
          v-for="(subcat, index) in patternsToDisplay"
          :key="index"
          :class="{active:subcat.stockLogoID === currentPattern?.stockLogoID}"
      >
        <div class="km__button--pattern subcat"
             :style="{ backgroundImage: 'url(' + '/logodatenbank/' + previewPath(subcat.stockLogoID) + '/' + subcat.stockLogoID + '-CategoryPreview.svg' + ')' }"
             @click="$emit('setCurrentPattern', subcat)"
        >
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts" setup>
import {useStore} from "vuex";
import {AnimationWaitingForTargetFactory, KEYFRAMETARGETS, KeyFrameTargetValues} from "@km/animations/animationFactory";
import {computed, PropType, watch} from "vue";
import {StockLogoCategory, StockLogoPoolEntry} from "@k/js/stocklogos/stocklogoController";
import gsap from "gsap";
import {
  scrollToActivePatternOrCategoryAfterRepaint
} from "@km/components/patternselection/scrollToActivePatternOrCategoryAfterRepaint";
import {useModuleColorOpenStateStore} from "@km/store/frontendstate/useModuleColorOpenState";

const props = defineProps({
  currentPatternCategory: {type: Object as PropType<StockLogoCategory>, required: true},
  currentPattern: Object as PropType<StockLogoPoolEntry>
})


const store = useStore();
const openStatusStore = useModuleColorOpenStateStore();
const animation = AnimationWaitingForTargetFactory.getLeftRightAnimationpercentWithOpacityAnimation(".km__modules__pattern--subcategories");
const keyFrames = new KeyFrameTargetValues({targetValue: -100, opacity: 1}, {targetValue: 0, opacity: 0});
watch(() => openStatusStore.getPatternState, (newValue: KEYFRAMETARGETS) => {
  animation(keyFrames.getTarget(newValue))
  if (newValue === KEYFRAMETARGETS.OPEN) {
    scrollToActivePatternOrCategoryAfterRepaint("km__modules__pattern--subcategories");
  }
});
watch(() => props.currentPattern, () => {
  scrollToActivePatternOrCategoryAfterRepaint("km__modules__pattern--subcategories");
})
watch(() => props.currentPatternCategory, () => {
  gsap.fromTo(".km__modules__pattern--subcategories", {y: 45, opacity: 0}, {duration: 0.5, y: 0, opacity: 1})
  gsap.fromTo(".km__modules__pattern--subcategories", {opacity: 0}, {duration: 1.0, opacity: 1})
  // animation(keyFrames.getTarget(KEYFRAMETARGETS.CLOSED))
  // setTimeout(()=>animation(keyFrames.getTarget(KEYFRAMETARGETS.OPEN)), 400)
})

const previewPath = id => id.toString().slice(-2);
const patternsToDisplay = computed(() => {
  return props.currentPatternCategory!.logos === undefined ? [] : props.currentPatternCategory!.logos.filter(l => l.discarded !== true)
});

</script>

<style lang="scss" scoped>
.km__modules__pattern--subcategories {
  position: fixed;
  width: 100%;
  height: 45px;
  right: -100%;
  bottom: calc(107px + #{$cta-height});
  z-index: 9999;
  overflow-y: hidden;
  opacity: 0;

  .km__list--modules {
    position: relative;
    overflow-x: scroll;
    width: 100%;
    -webkit-overflow-scrolling: touch;
    display: flex;
    flex-direction: row;
    padding-bottom: 15px;


    &.sub-pattern {
      padding-top: 43px;
    }

    .km__list__element--modules {
      padding: 6px 7px;

      &.active {
        .km__button--pattern {
          &:after {
            content: '';
            position: absolute;
            top: -5px;
            left: -5px;
            width: calc(100% + 10px);
            height: calc(100% + 10px);
            border: 2px solid $color-blue;
          }
        }
      }
    }

    .km__button--pattern {
      background-size: auto 30px;
    }
  }
}
</style>
